import ShareUserData from './share-user-data'

export default ShareUserData
